import { render, staticRenderFns } from "./ListImportCustomsPermitList.vue?vue&type=template&id=a02ad370&scoped=true&"
import script from "./ListImportCustomsPermitList.vue?vue&type=script&lang=js&"
export * from "./ListImportCustomsPermitList.vue?vue&type=script&lang=js&"
import style0 from "./ListImportCustomsPermitList.vue?vue&type=style&index=0&id=a02ad370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02ad370",
  null
  
)

export default component.exports